import { createFloatingRegistry } from 'hooks/useFloatingRegistry';

/**
 * EN-10420: registry for the POV seat's hole-cards element (keyed by seatId,
 * registered by Seat/modes/PortraitCurrentPlayer). Lets the POV's own bet
 * pill (Table/Bet) measure the cards and park itself a fixed gap above their
 * LIFTED position while the bet/raise tray is open — instead of tying two
 * unrelated coordinate systems (seat anchor vs. percentage-of-table cap)
 * together with device-specific magic pixels, which drifted on rotation and
 * across screen sizes.
 */
const { Context: PovCardsContext, Provider: PovCardsProvider } =
  createFloatingRegistry<number>('PovCards');

export default PovCardsContext;
export { PovCardsProvider };
